// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"478":"organization","943":"root"}[chunkId] || chunkId) + "." + {"478":"fe0ea8b5","654":"058f6ac4","903":"c5a0f3a0","943":"38e1dc4c"}[chunkId] + ".chunk.js";
};